import styled from "styled-components";

export const TitleWrapper = styled.div`
	font-size: 85%;
`;
